<template>
  <div>
  </div>
</template>
<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useNhsLoginSso } from '../composables/useNhsLoginSso';
  import { useRoute, useRouter } from 'vue-router';
  import { useSessionStore } from '../../stores/useSessionStore';
  import { useProvidedSessionInactivity } from '../composables/useProvidedSessionInactivity';
  import { useErrorStore } from '../../stores/useErrorStore';
  import { useUrlSegments } from '../composables/useUrlSegments';
  import { RequestTypeBroad } from '../../types';

  const router = useRouter();
  const route = useRoute();
  const session = useSessionStore();
  const inactivity = useProvidedSessionInactivity();
  const errorStore = useErrorStore();
  const { firstSegment } = useUrlSegments();

  async function navigateForRequestType(requestType: RequestTypeBroad) {
    if (requestType === 'medical-request') {
      await router.push('/medical-request/');
      return;
    }
    if (requestType === 'admin-request') {
      await router.push('/admin-request/');
      return;
    }
  }

  const nhsLoginSso = useNhsLoginSso({
    onNhsError: async ({ error }) => {
      const errorForStore = [{ code: error?.trim() }];
      errorStore.setErrors(errorForStore);
      errorStore.setIsNhsAppError(true);
    },
  });

  onMounted(async () => {
    const assertedLoginIdentity = route.query?.assertedLoginIdentity;
    if (await nhsLoginSso.checkForNhsErrorParams()) return;

    if (assertedLoginIdentity) {
      await nhsLoginSso.verifySsoTokenWithNhsLogin();
      return;
    }

    const authenticated = await nhsLoginSso.authenticateLoggedInUser();
    if (!authenticated) return;

    session.startSession(Date.now());
    inactivity.start();
    await navigateForRequestType(firstSegment.value as RequestTypeBroad);
  });
</script>
